import LeadgenForm from '@/entities/LeadgenForm';
import LeadgenFormLead from '@/entities/LeadgenFormLead';
import api from '@/services/Api';

export default {
  getList({ page, limit, sourceProfileIds }) {
    const data = {};
    if (page) {
      data['page'] = page;
    }
    if (limit) {
      data['limit'] = limit;
    }

    const query = new URLSearchParams(data);

    if (sourceProfileIds) {
      sourceProfileIds.forEach(id => query.append('source_profile_ids[]', id));
    }

    return api().get('/leadgen-forms?' + query.toString())
      .then(resp => resp.map(item => new LeadgenForm(item)));
  },

  getById(id, { campaignIds } = {}) {
    const query = new URLSearchParams();
    if (campaignIds) {
      campaignIds.forEach(id => query.append('campaign_ids[]', id));
    }

    return api().get('/leadgen-form/' + id + '?' + query.toString())
      .then(resp => new LeadgenForm(resp));
  },

  getLeads(leadgenFormId, { page, limit, campaignIds, statuses, assigneeIds, search }) {
    const data = {};
    if (page) {
      data['page'] = page;
    }
    if (limit) {
      data['limit'] = limit;
    }
    if (search) {
      data['q'] = search;
    }

    const query = new URLSearchParams(data);

    if (campaignIds) {
      campaignIds.forEach(id => query.append('campaign_ids[]', id));
    }
    if (statuses) {
      statuses.forEach(status => query.append('status[]', status));
    }
    // User ids, and "unassigned" for the leads without assignee.
    if (assigneeIds) {
      assigneeIds.forEach(id => query.append('assignee[]', id));
    }

    return api().get('/leadgen-form/' + leadgenFormId + '/leads?' + query.toString())
      .then(resp => resp.map(item => new LeadgenFormLead(item)));
  },

  refreshLeads(leadgenFormId) {
    return api().post('/leadgen-form/' + leadgenFormId + '/leads/refresh')
      .then(resp => new LeadgenForm(resp));
  },

  // The settings modal: notifications and the pixel of the lead statuses (null: the automation's).
  updateSettings(leadgenFormId, { notifications, crmPixel }) {
    return api().put('/leadgen-form/' + leadgenFormId + '/settings', {
      notifications: {
        enabled: notifications.enabled,
        to: notifications.to,
        emails: notifications.emails,
        frequency: notifications.frequency,
        hour: notifications.hour,
        include_lead_data: notifications.includeLeadData,
        rule_ids: notifications.ruleIds,
      },
      crm_pixel: crmPixel ? { ad_account_id: crmPixel.adAccountId, pixel_id: crmPixel.pixelId } : null,
    })
      .then(resp => new LeadgenForm(resp));
  },

  updateColumns(leadgenFormId, columns) {
    return api().put('/leadgen-form/' + leadgenFormId + '/columns', { columns })
      .then(resp => resp.columns);
  },

  downloadLeadsCSV(leadgenFormId, { campaignIds } = {}) {
    const data = {};
    const query = new URLSearchParams(data);

    if (campaignIds) {
      campaignIds.forEach(id => query.append('campaign_ids[]', id));
    }

    return api().get('/leadgen-form/' + leadgenFormId + '/leads/download?' + query.toString(), {
      responseType: 'blob',
    });
  },
};
